import { initializeiFrameListener } from 'listeners/iFrameListener';
import { handleError } from 'utils/errorHandler';

import { SmoochChatClient } from './clients/smoochChatClient';
import { type SupportClient } from './clients/supportClient';
import { SmoochChatService } from './services/smoochChatService';

interface InitializeV2ScriptParams {
  integrationKey: string;
  supportClient: SupportClient;
  scope: string;
}
export const initializeV2Script = ({
  integrationKey,
  supportClient,
  scope,
}: InitializeV2ScriptParams) => {
  try {
    // Create an instance of required clients
    const smoochChatClient = new SmoochChatClient(integrationKey);

    // Create an instance of required services
    const service = new SmoochChatService(
      smoochChatClient,
      supportClient,
      scope,
    );
    // Initialize the script
    initializeiFrameListener(service);
  } catch (error) {
    handleError(error);
  }
};
